import { render, staticRenderFns } from "./BsListView.vue?vue&type=template&id=2bea4d48&"
import script from "./BsListView.vue?vue&type=script&lang=js&"
export * from "./BsListView.vue?vue&type=script&lang=js&"
import style0 from "./BsListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports